
import React from "react";

import "./App.css";
import Feed from "./Feed";

import Header from "./Header";
import Sidebar from "./Sidebar";
import Widgets from "./Widgets";

function App() {
  return (
    <div className="app">
      {/* Header */}

      <Header />

      {/* App Body */}
      <div className="app__body">
        <Sidebar />
        <Feed />
        <Widgets />
      </div>
    </div>
  );
}

export default App;
